import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { LEAD_TYPES } from "../services/leadEmail";
import { submitLegacyLead } from "../services/legacyLeadSubmission";

function GoElectric2025() {
  const [submitted] = useState(false);
  const navigate = useNavigate();

  React.useEffect(() => {
    document.title = "Ford | Go electric";
  }, []);

  const marketingCampaign = async (data, slug) => {
    try {
      await submitLegacyLead({
        collectionName: slug,
        formData: data,
        firestoreData: {
          name: data.name ?? "",
          email: data.email ?? "",
          phone: data.phone ?? "",
          model: data.model ?? "",
          dealership: data.dealership ?? "",
          campaign: "GoElectric2025",
        },
        leadPayload: {
          type: LEAD_TYPES.CAMPAIGN_OFFER,
          vehicle: {
            model: data.model ?? "",
          },
          campaign: {
            slug,
          },
          title: "Go Electric 2025",
          message: `Запитване за модел ${data.model ?? ""}`.trim(),
        },
      });

      navigate("/thank-you-testdrive");
    } catch (error) {
      console.error("Грешка при запис в Firebase:", error);
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm();

  const onSubmit = (data) => marketingCampaign(data, "goelectric2025");
  return (
    <div className="text-gray-700 font-fordAntennaRegular">
      <section className="relative w-full">
        <picture>
          <source
            media="(max-width: 768px)"
            srcSet="/images/goelectric2025/ford-ev-range-mobile.jpg"
          />
          <img
            src="/images/goelectric2025/ford-ev-range-desktop.jpg"
            alt="Ford Go Electric 2025"
            className="object-cover w-full h-auto"
          />
        </picture>
        <div className="absolute inset-0">
          {/* Mobile overlays: title at top over top-gradient, subtitle at bottom over bottom-gradient */}
          <div className="absolute inset-0 md:hidden">
            {/* Top gradient + title */}
            <div className="absolute top-0 left-0 right-0">
              <div className="px-4 pt-16 pb-8 text-center text-white bg-gradient-to-b from-black/60 to-transparent">
                <h1 className="text-3xl font-bold leading-tight sm:text-3xl">
                  Усети пулса на бъдещето!
                </h1>
              </div>
            </div>
            {/* Bottom gradient + subtitle */}
            <div className="absolute bottom-0 left-0 right-0">
              <div className="px-4 pt-6 pb-10 text-center text-white bg-gradient-to-t from-black/60 to-transparent">
                <p className="text-lg leading-snug">
                  Новите изцяло електрически
                  <br />
                  модели на Ford сега с<br />
                  ексклузивни еко бонуси.
                </p>
              </div>
            </div>
          </div>

          {/* Desktop/Tablet: subtle bottom gradient under centered title + subtitle */}
          <div className="absolute inset-0 hidden md:block">
            {/* Bottom gradient band for readability */}
            <div className="absolute inset-x-0 bottom-0 h-48 bg-gradient-to-t from-black/50 to-transparent"></div>
            <div className="absolute inset-0 flex items-end">
              <div className="w-full px-4 pb-10 text-white">
                <div className="relative z-10 max-w-4xl mx-auto text-center">
                  <h1 className="text-5xl font-bold leading-tight">
                    Усети пулса на бъдещето!
                  </h1>
                  <p className="mt-3 text-xl leading-snug">
                    Новите изцяло електрически модели на Ford сега с ексклузивни
                    еко бонуси.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Секция заглавие */}
      <section className="py-24 bg-gray-100">
        <div className="max-w-3xl px-4 mx-auto mt-8 text-center">
          <p className="text-2xl font-bold">
            Бързо зареждане. Впечатляващ пробег. Стилен дизайн. Първокласен
            комфорт и богато оборудване.
          </p>
          <p className="mt-2 text-lg">
            Усетете пулса на бъдещето с новите изцяло електрически модели на
            Ford, които впечатляват във всяко отношение.
          </p>
        </div>
      </section>
      {/* Секция с модели */}
      <section className="mx-auto mt-32 max-w-[1400px] px-4 sm:px-6 md:px-12 xl:px-32">
        <div className="flex flex-col items-center gap-8 md:flex-row md:gap-16">
          <div className="flex-1 order-2 md:order-1">
            <h2 className="mb-6 text-3xl font-bold text-fordBlue">
              Ford Puma Gen-E<span className="text-xs align-super">®</span>
            </h2>
            <ul className="space-y-2 list-disc list-inside">
              <li>
                Градски пробег: до <span className="font-bold">572 км</span>
              </li>
              <li>
                Бързо зареждане (10–80%):{" "}
                <span className="font-bold">26 минути</span>
              </li>
              <li>
                Отличен разход:{" "}
                <span className="font-bold">
                  само 9,5 kWh в градски условия
                </span>{" "}
                в градски условия
              </li>
              <li>
                <span className="font-bold">Най-голям обем</span> на багажника в
                сегмента
              </li>
            </ul>
            <div className="flex flex-wrap items-center gap-4 mt-6">
              <a
                href="#contact"
                className="inline-flex items-center px-5 py-3 font-semibold text-white rounded-full bg-fordBlue hover:opacity-90"
              >
                Заявете оферта
              </a>
              <a
                href="https://ford.bg/cars/puma-gen-e"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-5 py-3 font-semibold border rounded-full border-fordBlue text-fordBlue hover:bg-fordBlue/5"
              >
                Научете повече
              </a>
            </div>
          </div>
          <div className="flex-1 order-1 md:order-2">
            <img
              src="/images/goelectric2025/puma-gen-e.jpeg"
              alt=""
              className="object-cover w-full h-auto overflow-hidden rounded-xl"
            />
          </div>
        </div>
        <div className="flex flex-col items-center gap-8 mt-12 md:flex-row md:gap-16 md:mt-32">
          <div className="flex-1 order-1 md:order-1">
            <img
              src="/images/goelectric2025/explorer.jpeg"
              alt=""
              className="object-cover w-full h-auto overflow-hidden rounded-xl"
            />
          </div>
          <div className="flex-1 order-2 md:order-2">
            <h2 className="mb-6 text-3xl font-bold text-fordBlue">
              Ford Explorer<span className="text-xs align-super">®</span>
            </h2>
            <ul className="space-y-2 list-disc list-inside">
              <li>
                Пробег: до <span className="font-bold">602 км</span>
              </li>
              <li>
                Бързо зареждане (10–80%):{" "}
                <span className="font-bold">26 минути</span>
              </li>
              <li>
                Ускорение от 0 до 100 км/ч:{" "}
                <span className="font-bold">само 5,3</span> секунди
              </li>
              <li>
                <span className="font-bold">Просторно купе</span> с модерни
                технологии
              </li>
            </ul>
            <div className="flex flex-wrap items-center gap-4 mt-6">
              <a
                href="#contact"
                className="inline-flex items-center px-5 py-3 font-semibold text-white rounded-full bg-fordBlue hover:opacity-90"
              >
                Заявете оферта
              </a>
              <a
                href="https://ford.bg/cars/new-explorer"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-5 py-3 font-semibold border rounded-full border-fordBlue text-fordBlue hover:bg-fordBlue/5"
              >
                Научете повече
              </a>
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center gap-8 mt-12 md:flex-row md:gap-16 md:mt-32">
          <div className="flex-1 order-2 md:order-1">
            <h2 className="mb-6 text-3xl font-bold text-fordBlue">
              Ford Capri<span className="text-xs align-super">®</span>
            </h2>
            <ul className="space-y-2 list-disc list-inside">
              <li>
                Пробег: до <span className="font-bold">627 км</span>
              </li>
              <li>
                Бързо зареждане (10–80%):{" "}
                <span className="font-bold">26 минути</span>
              </li>
              <li>
                Обем на багажника: <span className="font-bold">572 литра</span>
              </li>
              <li>
                <span className="font-bold">Просторно купе</span> с модерни
                технологии
              </li>
            </ul>
            <div className="flex flex-wrap items-center gap-4 mt-6">
              <a
                href="#contact"
                className="inline-flex items-center px-5 py-3 font-semibold text-white rounded-full bg-fordBlue hover:opacity-90"
              >
                Заявете оферта
              </a>
              <a
                href="https://ford.bg/cars/capri"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-5 py-3 font-semibold border rounded-full border-fordBlue text-fordBlue hover:bg-fordBlue/5"
              >
                Научете повече
              </a>
            </div>
          </div>
          <div className="flex-1 order-1 md:order-2">
            <img
              src="/images/goelectric2025/capri.jpeg"
              alt=""
              className="object-cover w-full h-auto overflow-hidden rounded-xl"
            />
          </div>
        </div>
        <div className="flex flex-col items-center gap-8 mt-12 md:flex-row md:gap-16 md:mt-32">
          <div className="flex-1 order-1 md:order-1">
            <img
              src="/images/goelectric2025/mach-e.jpeg"
              alt=""
              className="object-cover w-full h-auto overflow-hidden rounded-xl"
            />
          </div>
          <div className="flex-1 order-2 md:order-2">
            <h2 className="mb-6 text-3xl font-bold text-fordBlue">
              Ford Mustang Mach-E<span className="text-xs align-super">®</span>
            </h2>
            <ul className="space-y-2 list-disc list-inside">
              <li>
                Пробег: до <span className="font-bold">615 км</span>
              </li>
              <li>
                Ускорение от 0 до 100 км/ч:{" "}
                <span className="font-bold">само 3,5</span> секунди
              </li>
              <li>
                Впечатляващ,
                <span className="font-bold"> разпознаваем дизайн</span>
              </li>
              <li>
                <span className="font-bold">15,5-инчов</span> сензорен екран
              </li>
            </ul>
            <div className="flex flex-wrap items-center gap-4 mt-6">
              <a
                href="#contact"
                className="inline-flex items-center px-5 py-3 font-semibold text-white rounded-full bg-fordBlue hover:opacity-90"
              >
                Заявете оферта
              </a>
              <a
                href="https://ford.bg/cars/mustang-mach-e"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-5 py-3 font-semibold border rounded-full border-fordBlue text-fordBlue hover:bg-fordBlue/5"
              >
                Научете повече
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* Секция с икони */}
      <section className="w-full bg-gray-100 mt-36">
        <div className="max-w-3xl px-4 py-20 mx-auto">
          <div className="flex items-start justify-between pb-6 mb-8 border-b border-gray-200">
            <div className="flex justify-center w-24 shrink-0">
              <img
                src="/images/goelectric2025/car.png"
                alt=""
                className="object-contain w-auto h-auto"
              />
            </div>
            <div className="flex-1 pl-8">
              <p className="font-bold text-gray-900">
                Изцяло електрически модели
              </p>
              <p>
                Широка гама електрически автомобили Ford – сега с ексклузивни
                еко бонуси
              </p>
            </div>
          </div>
          <div className="flex items-start justify-between pb-6 mb-8 border-b border-gray-200">
            <div className="flex justify-center w-24 shrink-0">
              <img
                src="/images/goelectric2025/wheel.png"
                alt=""
                className="object-contain w-auto h-auto"
              />
            </div>
            <div className="flex-1 pl-8">
              <p className="font-bold text-gray-900">Богато оборудване</p>
              <p>
                Изберете електрически Ford, който отговаря на вашите желания и
                изисквания с всичко, от което се нуждаете, включено още в
                базовото оборудване.
              </p>
            </div>
          </div>
          <div className="flex items-start justify-between pb-6 mb-8 border-b border-gray-200">
            <div className="flex justify-center w-24 shrink-0">
              <img
                src="/images/goelectric2025/world.png"
                alt=""
                className="object-contain w-auto h-auto"
              />
            </div>
            <div className="flex-1 pl-8">
              <p className="font-bold text-gray-900">Готови за приключения</p>
              <p>
                Независимо дали покорявате градските улици, планинските пътища
                или сте на важна бизнес мисия, електрическите автомобили Ford ви
                осигуряват комфорт, динамика и вдъхновяващи преживявания на
                всяка крачка.
              </p>
            </div>
          </div>
          <div className="flex items-start justify-between pb-6 border-b border-gray-200">
            <div className="flex justify-center w-24 shrink-0">
              <img
                src="/images/goelectric2025/battery.png"
                alt=""
                className="object-contain w-auto h-auto"
              />
            </div>
            <div className="flex-1 pl-8">
              <p className="font-bold text-gray-900">Заредени на 100%</p>
              <p>
                Всички изцяло електрически модели ще ви вдъхновят с впечатляващ
                пробег и възможности за бързо зареждане.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Черна секция */}
      <section className="relative w-full">
        <picture>
          <source
            media="(max-width: 768px)"
            srcSet="/images/goelectric2025/ford-electric-tunnel-mobile.jpg"
          />
          <img
            src="/images/goelectric2025/ford-electric-tunnel-desktop.jpg"
            alt="Ford Electric Tunnel"
            className="object-cover w-full h-auto"
          />
        </picture>
        <div className="absolute bottom-0 left-1/2 w-full max-w-[1200px] -translate-x-1/2 px-8 py-4 md:py-12 text-white">
          <h2 className="text-xl font-bold md:mb-4 md:text-3xl">
            Силата на нашите електрически автомобили
          </h2>
          <p className="max-w-4xl md:leading-relaxed">
            Нашите модели използват високоефективни батерии с висока енергийна
            плътност, които осигуряват оптимална мощност и незабавен въртящ
            момент.
          </p>
        </div>
      </section>
      {/* Секция зареждане */}
      <section className="w-full py-20 mt-0 text-white bg-black">
        <div className="max-w-[1200px] mx-auto px-8 grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <h3 className="mb-4 text-2xl font-bold">Живот на батерията</h3>
            <p className="leading-relaxed">
              Всички наши батерии са проектирани с мисъл за издръжливост и
              дълготрайна ефективност.
            </p>
          </div>
          <div>
            <h3 className="mb-4 text-2xl font-bold">8-годишна гаранция</h3>
            <p className="leading-relaxed">
              Нашата 8-годишна или 160 000 км гаранция осигурява защита в
              случай, че батерията на вашия електрически автомобил загуби
              капацитет по-бързо от очакваното, като минималният гарантиран
              капацитет е 70%.
            </p>
          </div>
          <div>
            <h3 className="mb-4 text-2xl font-bold">Рециклируема батерия</h3>
            <p className="leading-relaxed">
              До 95% от елементите, използвани при производството, могат да
              бъдат рециклирани и използвани повторно за изработката на нови
              батерии за електрически превозни средства.
            </p>
          </div>
        </div>
      </section>
      <section className="w-full py-20 text-white bg-black">
        <div className="max-w-[1200px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-12 items-center px-8">
          <div className="md:col-span-5">
            <img
              src="/images/goelectric2025/recharge.jpg"
              alt="Ford Recharge"
              className="object-cover w-full h-auto shadow-lg rounded-xl"
            />
          </div>
          <div className="md:col-span-7">
            <h3 className="mb-4 text-3xl font-bold">Бързо зареждане</h3>
            <p className="leading-relaxed">
              Нашите батерии поддържат бързо зареждане без риск от дългосрочно
              увреждане, което ви позволява да се върнете на пътя за по-кратко
              време.
            </p>
          </div>
        </div>
      </section>
      <section id="contact" className="w-full py-20 text-gray-900 bg-white">
        <div className="max-w-[900px] mx-auto px-6">
          <h2 className="mb-6 text-3xl font-bold text-center text-fordBlue">
            Все още се колебаете?
          </h2>
          <p className="mb-10 text-center text-gray-600">
            Свържете се с най-близкия представител на Ford, за да получите
            съдействие при избора на най-подходящия модел за вас.
          </p>

          {submitted && (
            <div className="p-4 mb-6 text-green-800 border border-green-200 rounded-lg bg-green-50">
              Благодарим! Формулярът е изпратен успешно. Ще се свържем с вас
              скоро.
            </div>
          )}

          <form
            onSubmit={handleSubmit(onSubmit)}
            id="templateCampaignForm"
            noValidate
          >
            <div className="grid grid-cols-1 gap-6">
              <div>
                <label
                  className="block mb-1 text-sm font-medium"
                  htmlFor="name"
                >
                  Име
                </label>
                <input
                  id="name"
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md outline-none focus:ring-2 focus:ring-fordBlue focus:border-fordBlue"
                  placeholder="Вашето име"
                  {...register("name", {
                    required: "Моля, въведете име",
                    minLength: { value: 2, message: "Минимум 2 символа" },
                  })}
                />
                {errors.name && (
                  <p className="mt-1 text-sm text-red-600">
                    {errors.name.message}
                  </p>
                )}
              </div>

              <div>
                <label
                  className="block mb-1 text-sm font-medium"
                  htmlFor="email"
                >
                  Имейл
                </label>
                <input
                  id="email"
                  type="email"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md outline-none focus:ring-2 focus:ring-fordBlue focus:border-fordBlue"
                  placeholder="name@example.com"
                  {...register("email", {
                    required: "Моля, въведете имейл",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Невалиден имейл адрес",
                    },
                  })}
                />
                {errors.email && (
                  <p className="mt-1 text-sm text-red-600">
                    {errors.email.message}
                  </p>
                )}
              </div>

              <div>
                <label
                  className="block mb-1 text-sm font-medium"
                  htmlFor="phone"
                >
                  Телефон
                </label>
                <input
                  id="phone"
                  type="tel"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md outline-none focus:ring-2 focus:ring-fordBlue focus:border-fordBlue"
                  placeholder="08xx xxx xxx"
                  {...register("phone", {
                    required: "Моля, въведете телефон",
                    minLength: { value: 6, message: "Минимум 6 цифри" },
                  })}
                />
                {errors.phone && (
                  <p className="mt-1 text-sm text-red-600">
                    {errors.phone.message}
                  </p>
                )}
              </div>

              <div>
                <label
                  className="block mb-1 text-sm font-medium"
                  htmlFor="model"
                >
                  Модел
                </label>
                <select
                  id="model"
                  className="w-full px-3 py-2 bg-white border border-gray-300 rounded-md outline-none focus:ring-2 focus:ring-fordBlue focus:border-fordBlue"
                  {...register("model", {
                    required: "Моля, изберете модел",
                  })}
                >
                  <option value="" disabled selected>
                    Моля, изберете
                  </option>
                  <option value="puma-gen-e">Puma Gen-E</option>
                  <option value="explorer">Explorer</option>
                  <option value="capri">Capri</option>
                  <option value="mustang-mach-e">Mustang Mach-E</option>
                </select>
                {errors.model && (
                  <p className="mt-1 text-sm text-red-600">
                    {errors.model.message}
                  </p>
                )}
              </div>
            </div>

            <div className="mt-6">
              <label htmlFor="dealership" className="text-gray-500">
                Предпочитано представителство
              </label>
              <select
                name="dealership"
                id="dealership"
                {...register("dealership", {
                  required: {
                    value: true,
                    message: "Моля, изберете представителство",
                  },
                })}
                className="w-full px-3 py-2 bg-white border border-gray-300 rounded-md outline-none focus:ring-2 focus:ring-fordBlue focus:border-fordBlue"
              >
                <option value="" disabled selected>
                  Моля, изберете
                </option>
                <option value="liulin2@motopfohe.bg">София Люлин</option>
                <option value="mladost@motopfohe.bg">София Младост</option>
                <option value="blagoevgrad@motopfohe.bg">Благоевград</option>
                <option value="burgas@motopfohe.bg">Бургас</option>
                <option value="varna@motopfohe.bg">Варна</option>
                <option value="velikotarnovo@motopfohe.bg">
                  Велико Търново
                </option>
                <option value="gabrovo@motopfohe.bg">Габрово</option>
                <option value="dobrich@motopfohe.bg">Добрич</option>
                <option value="montana@motopfohe.bg">Монтана</option>
                <option value="pleven@motopfohe.bg">Плевен</option>
                <option value="plovdiv@motopfohe.bg">Пловдив</option>
                <option value="russe@motopfohe.bg">Русе</option>
                <option value="starazagora@motopfohe.bg">Стара Загора</option>
                <option value="smolyan@motopfohe.bg">Смолян</option>
                <option value="g.draganov@autobox.bg">Хасково</option>
                <option value="forsh@motopfohe.bg">Шумен</option>
              </select>
              {errors.dealership && (
                <p className="mt-1 text-sm text-red-600">
                  {errors.dealership.message}
                </p>
              )}
            </div>

            <input type="hidden" name="title" value="goelectric2025" />

            <div className="flex justify-center mt-8">
              <button
                type="submit"
                disabled={isSubmitting}
                className="inline-flex items-center px-6 py-3 font-semibold text-white rounded-md bg-fordBlue hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fordBlue disabled:opacity-60"
              >
                {isSubmitting ? "Изпращане..." : "Изпрати"}
              </button>
            </div>
          </form>
        </div>
      </section>
    </div>
  );
}

export default GoElectric2025;
